import { getLightenColor, getDarkenColor } from './'
export default (type, colors) => {
  const styles = {
    default: {
      'c-mviewer__map-tool-opacity': {
        backgroundColor: colors.secondary,
        boxShadow: `1px 1px 0 0 ${colors.secondary}`,
      },
      'c-mviewer__map-tool-opacity-label-short': {
        backgroundColor: colors.secondary,
        boxShadow: `1px 1px 0 0 ${colors.secondary}`,
      },
      'c-mviewer__multi-image-item': {
        customCSS: `
          .c-mviewer__multi-image-item a:hover,
          .c-mviewer__multi-image-item a:active,
          .c-mviewer__multi-image-item a:focus {
            box-shadow: 0 0 10px 0 rgba(${getLightenColor(colors.secondary, 0.23)}, 1), 0 0 30px 0 rgba(${getLightenColor(colors.primary, 0.15)}, 1);
          }
          .c-mviewer__object:before, 
          .c-mviewer__multi-image-item a:before {
            color: ${colors.secondary};
          }
        `
      },
      'c-mviewer__multi-page-num': {
        customCSS: `
          .c-mviewer__multi-page-num .badge {
            background: ${colors.secondary_dark};
          }
        `
      }
    },
    type1: {
      'c-mviewer__layout--fixed': {
        customCSS: `
          .c-mviewer__layout--fixed {
            height: calc( 100vh - 300px);
          }
          @media screen and (max-width: 30em) {
            .c-mviewer__layout--fixed {
              height: calc( 72vh - (24px * 3));
            }
          }
        `
      },
      'c-mviewer': {
        background: getDarkenColor(colors.light, 0.03),
        backgroundImage: 'url(../../images/bg-texture.png)',
      },
      'c-mviewer__tools': {
        customCSS: `
          @media screen and (min-width: 48em) {
            .c-mviewer__tools .button {
              height: 44px;
              width: 44px;
              line-height: 44px;
            }
            .c-mviewer__tools .button  .icon {
              font-size: 20px;
            }
            .c-mviewer__tools {
              right: 1em;
              background: ${colors.light};
              border-radius: 6px;
              padding: 4px;
            }
          }
          @media screen and (max-width: 48em) {
            .state-has-overlap .c-mviewer__tools {
              bottom: 20px;
              top: inherit!important;
            }
          }
          .c-mviewer__media-missing {
            color: ${colors.dark};
          }
          .state-has-overlap .c-mviewer__tools {
            margin-bottom: 0;
            bottom: 20px;
          }
          .c-mviewer__tools .button {
            box-shadow: none;
            background-color: ${colors.light};
          }
          .c-mviewer__tools .icon {
            color: ${colors.dark};
          }
          [data-whatinput="mouse"] .c-mviewer__tools {
            opacity: 1;
          }
        `
      },
      'c-mviewer__map-tool-opacity': {
        backgroundColor: colors.secondary,
        boxShadow: `1px 1px 0 0 ${colors.secondary}`,
      },
      'c-mviewer__map-tool-opacity-label-short': {
        backgroundColor: colors.secondary,
        boxShadow: `1px 1px 0 0 ${colors.secondary}`,
      },
      'c-mviewer__multi-image-item': {
        customCSS: `
          .c-mviewer__multi-image-item a:hover,
          .c-mviewer__multi-image-item a:active,
          .c-mviewer__multi-image-item a:focus {
            box-shadow: 0 0 10px 0 rgba(${getLightenColor(colors.secondary, 0.23)}, 1), 0 0 30px 0 rgba(${getLightenColor(colors.primary, 0.15)}, 1);
          }
          .c-mviewer__object:before, 
          .c-mviewer__multi-image-item a:before {
            color: ${colors.primary};
          }
        `
      },
      'c-mviewer__multi-page-num': {
        customCSS: `
          .c-mviewer__multi-page-num .badge {
            background: ${colors.secondary_dark};
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cMviewer.js